// Aspetto (stile delle linee) — gemello di theme.js. Cambia solo raggi/bordi/ombre.
export const ASPETTI = [
  { id: 'spigoloso', label: 'Spigoloso' },
  { id: 'morbido', label: 'Morbido' },
];

const VALIDI = ASPETTI.map((a) => a.id);

export function getAspetto() {
  try {
    const v = localStorage.getItem('appAspetto');
    return VALIDI.includes(v) ? v : 'spigoloso';
  } catch (e) {
    return 'spigoloso';
  }
}

export function setAspetto(id) {
  const val = VALIDI.includes(id) ? id : 'spigoloso';
  try { localStorage.setItem('appAspetto', val); } catch (e) {}
  document.documentElement.setAttribute('data-aspetto', val);
}
